import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowPathLeft"><Path d="M21.5 15.5V8.5H10.5V4.75L1.75 12L10.5 19.25V15.5H21.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowPathLeft;
